import { v4 as uuid } from 'uuid'

export interface IProductPricing {
  id: string
  description: string
  price: number
  quantityType?: string
}

export class ProductPricing implements IProductPricing {
  public id: string
  public price: number = 0
  public quantityType?: string

  constructor(public description: string) {
    this.id = uuid()
  }
}
